import React from 'react';
import theme from './Indicator.module.scss';
import { IndicatorProps } from '.';

const Indicator: React.FC<IndicatorProps> = ({ children, className, color }) => {
    const classNames: string[] = [theme.indicator];

    if (className) {
        classNames.push(className);
    }

    if (color) {
        classNames.push(theme[color]);
    }

    return <span className={classNames.join(' ')}>{children}</span>;
};

export default Indicator;
